import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Menus from "../components/Menus.jsx";
import { getMenusByBranch, getMenuCategoriesByBranch } from "../api/menus.js";
import { getBranch } from "../api/branches.js";

const normalizeMenus = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.menus)) {
    return payload.menus;
  }

  if (Array.isArray(payload?.data?.menus)) {
    return payload.data.menus;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

const getErrorMessage = (error) => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }

  if (error.message) {
    return error.message;
  }

  return "Please try again in a moment.";
};

const MenusPage = () => {
  const { id } = useParams();
  const [menus, setMenus] = useState([]);
  const [merchant, setMerchant] = useState(null);
  const [branch, setBranch] = useState(null);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchMenus = useCallback(async () => {
    if (!id) {
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const [data, branchData, categoryData] = await Promise.all([
        getMenusByBranch(id),
        getBranch(id).catch(() => null),
        getMenuCategoriesByBranch(id).catch(() => []),
      ]);
      const nextMenus = normalizeMenus(data);

      setBranch(branchData);
      setCategories(Array.isArray(categoryData) ? categoryData : []);
      setMenus(nextMenus);
      setMerchant(nextMenus.find((menu) => menu?.merchant)?.merchant || null);
    } catch (fetchError) {
      setMenus([]);
      setMerchant(null);
      setBranch(null);
      setCategories([]);
      setError(getErrorMessage(fetchError));
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchMenus();
  }, [fetchMenus]);

  if (!id) {
    return (
      <main className="min-h-screen bg-gray-50 px-4 py-16">
        <div className="max-w-2xl mx-auto bg-white border border-gray-100 rounded-lg p-8 text-center shadow-sm">
          <h1 className="text-2xl font-bold text-gray-950">
            Branch id is required
          </h1>
          <p className="mt-2 text-gray-600">
            Open this page with a branch id, for example `/menus/1`.
          </p>
          <Link
            to="/"
            className="mt-6 inline-flex rounded-md bg-primary-color px-4 py-2 font-semibold text-white hover:opacity-90 transition"
          >
            Back to home
          </Link>
        </div>
      </main>
    );
  }

  return (
    <Menus
      branchId={id}
      branch={branch}
      categories={categories}
      error={error}
      isLoading={isLoading}
      menus={menus}
      merchant={merchant}
      onRetry={fetchMenus}
    />
  );
};

export default MenusPage;
